{
  "scheduleDashboard": {
    "title": "Programme du vol",
    "alerts": {
      "selectFBO": "Veuillez sélectionner un FBO pour consulter le planning."
    },
    "viewModes": {
      "timeline": "Chronologie",
      "timelineTooltip": "Afficher les vols dans un diagramme de Gantt",
      "table": "Tableau",
      "tableTooltip": "Afficher les vols dans un tableau détaillé"
    },
    "buttons": {
      "createTrip": "Créer un vol",
      "bulkImport": "Import groupé"
    },
    "filters": {
      "locationCount": "Filtré : {{count}} emplacement",
      "statusLabel": "Statut",
      "statusOptions": {
        "all": "Tout statut",
        "scheduled": "Planifié",
        "active": "Actif",
        "completed": "Terminé",
        "cancelled": "Annulé",
        "requested": "Demandé",
        "confirmed": "Confirmé",
        "tenant-based": "Basé sur le client",
        "transient": "Passager",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "Tout statut",
        "requested": "Demandé",
        "confirmed": "Confirmé",
        "completed": "Terminé",
        "cancelled": "Annulé"
      },
      "tailNumberLabel": "Filtrer par immatriculation",
      "tailNumberPlaceholder": "N123AB",
      "showPastTrips": "Vols passés"
    },
    "errors": {
      "timelineTitle": "Erreur de chronologie",
      "timelineDescription": "Une erreur s'est produite lors du chargement de la vue chronologique. Veuillez actualiser la page ou passer à la vue tableau."
    },
    "emptyState": "Aucun vol prévu pour la période sélectionnée"
  },
  "scheduleList": {
    "columns": {
      "tailNumber": "Immatriculation",
      "aircraftModel": "Modèle d'aéronef",
      "type": "Type",
      "arrival": "Arrivée",
      "departure": "Départ",
      "status": "Statut",
      "notes": "Notes",
      "ownerManager": "Propriétaire/Gérant",
      "assignment": "Attribution",
      "actions": "Actions"
    },
    "tooltips": {
      "editTrip": "Modifier"
    },
    "dateRange": "Affichage des vols du {{startDate}} au {{endDate}}",
    "tripCount": "Affichage de {{filtered}} sur {{total}} vols",
    "filters": {
      "tailNumberLabel": "Filtrer par immatriculation",
      "tailNumberPlaceholder": "p. ex. N123AB",
      "statusLabel": "Statut",
      "statusOptions": {
        "all": "Tout statut",
        "scheduled": "Planifié",
        "active": "Actif",
        "completed": "Terminé",
        "cancelled": "Annulé",
        "requested": "Demandé",
        "confirmed": "Confirmé",
        "tenant-based": "Basé sur le client",
        "transient": "Passager",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "Tout statut",
        "requested": "Demandé",
        "confirmed": "Confirmé",
        "completed": "Terminé",
        "cancelled": "Annulé"
      }
    },
    "noTripsFound": "Aucun vol trouvé",
    "bulkActions": {
      "selected": "{{count}} sélectionnés",
      "setStatus": "Changer le statut",
      "assignLocation": "Attribuer un emplacement",
      "cancel": "Annuler les vols",
      "delete": "Supprimer",
      "clearSelection": "Effacer la sélection",
      "deleteConfirmTitle": "Supprimer les vols sélectionnés",
      "deleteConfirmMessage": "Voulez-vous vraiment supprimer définitivement {{count}} vol(s) ? Cette action est irréversible.",
      "deleteConfirmButton": "Supprimer",
      "cancelConfirmTitle": "Annuler les vols sélectionnés",
      "cancelConfirmMessage": "Voulez-vous vraiment annuler {{count}} vol(s) ? Leur statut passera à « annulé ».",
      "cancelConfirmButton": "Annuler les vols",
      "statusSuccess": "Statut mis à jour pour {{count}} vols",
      "statusPartial": "{{successCount}} vols mis à jour ({{failCount}} échec(s))",
      "deleteSuccess": "{{count}} vols supprimés",
      "cancelSuccess": "{{count}} vols annulés",
      "assignSuccess": "{{count}} vols attribués à {{locationName}}"
    }
  },
  "scheduleTimeline": {
    "tooltip": {
      "location": "Lieu : {{name}}"
    },
    "deleteConfirmation": {
      "title": "Supprimer la sélection",
      "message": "Voulez-vous vraiment supprimer {{count}} vol sélectionné ? Cette action est irréversible.",
      "deleteButton": "Supprimer",
      "cancelButton": "Annuler"
    }
  },
  "scheduledHangarView": {
    "updating": "Mise à jour...",
    "addObstacleDialog": {
      "title": "Ajouter un obstacle mobile",
      "cancelButton": "Annuler",
      "doneButton": "Fait"
    },
    "errors": {
      "noData": {
        "title": "Aucune donnée hangar disponible",
        "description": "Impossible de charger les informations du hangar pour cette période. Essayez d'actualiser la page ou de sélectionner une autre période.",
        "actionLabel": "Actualiser"
      }
    }
  },
  "scheduledRampView": {
    "errors": {
      "noData": {
        "title": "Aucune donnée de tarmac disponible",
        "description": "Impossible de charger les informations du tarmac pour cette période. Essayez d'actualiser la page ou de sélectionner une autre période.",
        "actionLabel": "Actualiser"
      }
    },
    "addObstacleDialog": {
      "title": "Ajouter un obstacle mobile",
      "buttons": {
        "cancel": "Annuler",
        "done": "Fait"
      }
    }
  },
  "assignLocationDialog": {
    "title": "Attribuer un aéronef à un emplacement",
    "keepUnassigned": "Garder non assigné",
    "current": "Actuel",
    "sections": {
      "hangars": "Hangars",
      "ramps": "Tarmacs"
    },
    "customTimeRange": "Période personnalisée",
    "fields": {
      "startTime": "Heure de début",
      "endTime": "Heure de fin"
    },
    "messages": {
      "noLocationsAvailable": "Aucun lieu disponible pour la période sélectionnée.",
      "unassignedPeriodsWarning": "Des périodes non assignées seront créées avant/après cette plage horaire"
    },
    "buttons": {
      "cancel": "Annuler",
      "assign": "Attribuer",
      "assigning": "Attribution..."
    }
  },
  "tripLocationNavigationDialog": {
    "title": "Vol à un autre emplacement",
    "labels": {
      "tripLocation": "LIEU DU VOL",
      "youreViewing": "VOUS CONSULTEZ"
    },
    "messages": {
      "unassignedTrip": "Ce vol n'a pas encore été attribué à un lieu spécifique.",
      "unassignedExplanation": "Vous pouvez consulter la période pendant laquelle ce vol est programmé, mais il n'a pas d'affectation de hangar ou de tarmac.",
      "unassignedPrompt": "Choisissez si vous souhaitez accéder à cette période dans votre vue actuelle.",
      "assignedPrompt": "Choisissez de naviguer vers l'emplacement du vol ou de rester sur votre vue actuelle."
    },
    "buttons": {
      "cancel": "Annuler",
      "stayIn": "Rester à {{locationName}}",
      "goTo": "Aller à {{locationName}}"
    }
  },
  "currentTimeControl": {
    "labels": {
      "currentTime": "Heure actuelle",
      "viewing": "Période : {{startDate}} - {{endDate}}"
    },
    "buttons": {
      "now": "Mnt"
    }
  },
  "createTripDialog": {
    "title": {
      "create": "Créer un nouveau vol",
      "newTripFor": "Nouveau vol pour {{tailNumber}}"
    },
    "labels": {
      "ownerManager": "Propriétaire/Gérant",
      "type": "Type",
      "status": "Statut",
      "searchAircraft": "Rechercher par marque et modèle",
      "arrivalDateTime": "Date et heure d'arrivée",
      "departureDateTime": "Date et heure de départ",
      "notes": "Notes",
      "noDeparture": "Aucun départ",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "p. ex., Jean Dupont",
      "notes": "Exigences particulières ou remarques..."
    },
    "tenantTypes": {
      "transient": "Passage",
      "base": "Base",
      "yellowCard": "Base + Carte Jaune"
    },
    "messages": {
      "noScheduledDeparture": "Cet aéronef restera au FBO indéfiniment sans départ prévu.",
      "unassigned": "L'aéronef sera initialement placé comme « non attribué » et pourra être positionné dans un hangar ou sur un tarmac après sa création.",
      "autoAssigned": "Ce vol sera automatiquement assigné à l'emplacement {{locationType}} actuel.",
      "autoAssignedSimple": "Le vol sera créé pour cet appareil et pourra être positionné après sa création."
    },
    "buttons": {
      "cancel": "Annuler",
      "create": "Créer un vol"
    },
    "tooltips": {
      "conflict": "Impossible de créer le vol - chevauchement avec un vol existant",
      "fillRequired": "Veuillez remplir tous les champs obligatoires"
    }
  },
  "locationFilter": {
    "label": "Filtrer par lieu",
    "placeholder": "Tous les sites",
    "groups": {
      "hangars": "Hangars",
      "ramps": "Tarmacs"
    }
  },
  "tripEditForm": {
    "labels": {
      "tailNumber": "Immatriculation",
      "ownerManager": "Propriétaire/Gérant",
      "aircraftModel": "Modèle d'aéronef",
      "status": "Statut",
      "arrival": "Arrivée",
      "departure": "Départ",
      "notes": "Notes",
      "noDeparture": "Aucun départ",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "Nom du propriétaire ou gestionnaire",
      "notes": "Ajouter des notes sur ce vol..."
    },
    "statuses": {
      "scheduled": "Planifié",
      "active": "Actif",
      "completed": "Terminé",
      "cancelled": "Annulé"
    },
    "messages": {
      "baseTenant": "Locataire base",
      "noScheduledDeparture": "Cet aéronef n'a aucun départ prévu",
      "indefiniteStay": "Cet appareil restera au FBO indéfiniment sans départ prévu."
    },
    "buttons": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistr…"
    }
  },
  "simpleBulkUpload": {
    "title": "Import groupé de vols",
    "pasteExcel": {
      "title": "Coller depuis Excel",
      "description": "Copiez les données du vol depuis Excel (Immatriculation, Date d'arrivée, Date de départ) et collez-les ci-dessous. Pour les locataires basés, laissez la colonne de départ vide ou utilisez « pas de départ ». Les en-têtes sont facultatifs et seront automatiquement détectés et ignorés.",
      "importButton": "Importer",
      "importing": "Importation...",
      "sampleFileButton": "Fichier exemple",
      "rowsReady": "{{count}} lignes prêtes à importer"
    },
    "editTrips": {
      "title": "Modifier vols",
      "tableHeaders": {
        "tailNumber": "Immatriculation",
        "aircraft": "Aéronef",
        "arrivalDate": "Date d'arrivée",
        "departureDate": "Date de départ"
      },
      "addButton": "Ajouter",
      "selectAircraft": "Sélectionner l'aéronef",
      "placeholders": {
        "tailNumber": "N123AB"
      },
      "validationErrors": {
        "arrivalBeforeDeparture": "L'arrivée doit être avant le départ",
        "departureAfterArrival": "Le départ doit être après l'arrivée"
      }
    },
    "messages": {
      "autoAssign": "Les vols seront automatiquement assignés à {{locationName}}",
      "validTripsCount": "{{count}} vols valides"
    },
    "buttons": {
      "cancel": "Annuler",
      "save": "Enregistrer {{count}} vols"
    },
    "progress": {
      "uploadingTitle": "Envoi des vols",
      "uploadingMessage": "Création des vols et attribution à l'emplacement. Veuillez patienter...",
      "itemName": "vol"
    },
    "sampleFile": {
      "header": "Immatriculation\tDate d'arrivée\tDate de départ"
    },
    "errors": {
      "noActiveFBO": "Aucun FBO actif sélectionné",
      "noValidTrips": "Aucun vol valide à enregistrer",
      "missingAircraftData": "Impossible de téléverser les vols sans données d'aéronef. Veuillez sélectionner un aéronef pour : {{tailNumbers}}",
      "failedTenantSearch": "Échec de la recherche du locataire : {{message}}",
      "missingAircraftId": "Erreur interne : le vol n'a pas d'aircraft_id pour {{tailNumber}} - aurait dû être détecté par la validation",
      "failedTenantCreate": "Échec de la création du client : {{message}}",
      "assignmentFailed": "{{tailNumber}} : Vol créé mais l'affectation a échoué - {{message}}",
      "unknownError": "Erreur inconnue",
      "tripCreationFailed": "{{tailNumber}} : {{message}}",
      "saveFailed": "Échec de l'enregistrement des vols. Veuillez réessayer."
    },
    "success": {
      "allSucceeded": "✓ {{count}} vol{{locationMessage}} ajouté avec succès",
      "partialSuccess": "✓ {{successCount}} vol(s) sur {{totalCount}} ajouté(s) avec succès{{locationMessage}}.\n\n✗ {{failedCount}} échec(s) :\n{{errors}}",
      "allFailed": "✗ Échec de l'ajout des vols :\n{{errors}}"
    },
    "successState": {
      "dialogTitle": "Import terminé",
      "title": "Vols créés avec succès",
      "message": "{{count}} vol(s) ajouté(s) au planning.",
      "assignedTo": "Assigné(s) à {{locationName}}.",
      "viewTrips": "Voir les vols",
      "done": "Terminé"
    }
  },
  "tripDetailsModal": {
    "title": "Détails du vol",
    "buttons": {
      "newTrip": "Nouveau vol",
      "view": "Voir",
      "edit": "Édit.",
      "close": "Fermer",
      "cancelTrip": "Annuler le vol",
      "deleteTrip": "Supprimer",
      "assignToLocation": "Attribuer à un emplacement",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "deleting": "Suppression...",
      "cancelling": "Annulation...",
      "cancel": "Annuler",
      "keepTrip": "Garder le vol"
    },
    "labels": {
      "tailNumber": "Immatriculation",
      "ownerManager": "Propriétaire/Gérant",
      "aircraft": "Aéronef",
      "arrival": "Arrivée",
      "departure": "Départ",
      "duration": "Durée",
      "notes": "Notes",
      "locationHistory": "Historique des positions",
      "tripNavigation": "Navigation des vols"
    },
    "placeholders": {
      "ownerManager": "Nom du propriétaire ou gestionnaire",
      "notes": "Ajouter notes...",
      "unknown": "Inconnu",
      "noNotes": "Aucune note",
      "unassigned": "Non attribué"
    },
    "chips": {
      "transient": "Passager"
    },
    "duration": {
      "indefinite": "Indéfini",
      "days": "{{days}}j {{hours}}h {{minutes}}m",
      "hours": "{{hours}}h {{minutes}}m",
      "minutes": "{{minutes}} min"
    },
    "tableHeaders": {
      "location": "Emplacement",
      "arrival": "Arrivée",
      "departure": "Départ",
      "duration": "Durée"
    },
    "navigation": {
      "previous": "Précédent : {{dates}}",
      "next": "Suivant : {{dates}}",
      "noOtherTrips": "Aucun autre vol"
    },
    "confirmations": {
      "deleteTitle": "Supprimer",
      "deleteMessage": "Voulez-vous vraiment supprimer définitivement ce vol pour {{tailNumber}} ? Cette action est irréversible et supprimera tout l'historique des placements.",
      "cancelTitle": "Annuler le vol",
      "cancelMessage": "Voulez-vous vraiment annuler ce vol pour {{tailNumber}} ? Le statut du vol passera à « annulé » et cette action ne pourra pas être facilement annulée."
    },
    "tooltips": {
      "unassigned": "L'aéronef n'est pas affecté à un hangar ou à un emplacement sur le tarmac pendant cette période. Il peut être en stationnement transit ou en attente d'affectation d'emplacement."
    }
  },
  "aircraftTripsModal": {
    "title": "Vols pour {{tailNumber}}",
    "emptyState": {
      "title": "Aucun vol trouvé",
      "description": "Cet aéronef n'a pas encore de vols programmés."
    },
    "tripCount": "Affichage de {{count}} vol",
    "clickToView": "Cliquez sur un vol pour les détails",
    "viewingTrip": "Consultation du vol pour {{tailNumber}}",
    "duration": {
      "daysAndHours": "{{days}} jour, {{hours}} h",
      "hoursAndMinutes": "{{hours}} h, {{minutes}} min",
      "minutes": "{{minutes}} min"
    },
    "tripDetails": {
      "title": "Détails du vol",
      "editTooltip": "Modifier",
      "unknown": "Inconnu",
      "labels": {
        "aircraft": "Aéronef",
        "arrival": "Arrivée",
        "departure": "Départ",
        "duration": "Durée",
        "notes": "Notes"
      }
    }
  },
  "scheduleListPage": {
    "alerts": {
      "selectFBO": "Sélectionner FBO"
    },
    "buttons": {
      "createFirstTrip": "Créer un premier vol",
      "createTrip": "Créer un vol",
      "timelineView": "Vue chronologique"
    },
    "emptyState": {
      "description": "Description",
      "title": "État vide"
    },
    "title": "Liste des plannings"
  }
}
